import React, { useState } from "react";
import { DebounceInput } from "react-debounce-input";
import classNames from "classnames";
import "./index.scss";

const SearchControl = ({ value, placeholder, onChange, debounce }) => {
  const [inputText, setInputText] = useState("");
  const handleOnChange = value => {
    setInputText(value);
    onChange(value);
  };
  return (
    <div className={classNames("searchControl")}>
      <div className={classNames("searchWrapper")}>
        <DebounceInput
          autoComplete="new-password"
          list="autocompleteOff"
          className={classNames("searchInput")}
          placeholder={placeholder || ""}
          debounceTimeout={debounce || 3000}
          onChange={event => handleOnChange(event.target.value)}
          value={value || inputText || ''}
        />
        {!!(value || inputText) && (
          <div
            className={classNames("clearSearch")}
            onClick={() => handleOnChange("")}
          />
        )}
      </div>
    </div>
  );
};

export default SearchControl;
